import { observer } from 'mobx-react';
import * as React from 'react';
import { ISuggestionItem, LargeSearch, SuggestionField, useCurrentBreakPoint } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { useStores } from '../stores/RootStore';

const RoamingCountrySearch = observer((): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const currentBreakPoint = useCurrentBreakPoint();

  const {
    roamingStore,
    segmentStore: { currentSegment },
  } = useStores();

  const inputLabelKey = currentBreakPoint === 'xs' ? 'roaming.search.placeholder.mobile' : 'roaming.search.placeholder';

  return (
    <>
      <LargeSearch
        id="roaming-large-search"
        align="center"
        onSubmit={(e) => {
          e.preventDefault();
          const suggestions = roamingStore.countrySuggestionItems;
          if (suggestions.length > 0) {
            roamingStore.countrySuggestionSearchTerm = suggestions[0].label;
            return roamingStore.selectCountrySuggestionItem(suggestions[0], currentSegment);
          }
        }}
      >
        <SuggestionField
          id="roaming-search"
          label={translate(inputLabelKey)}
          items={roamingStore.countrySuggestionItems}
          placeholderLabel={true}
          value={roamingStore.countrySuggestionSearchTerm}
          onChange={(input: string) => roamingStore.handleCountryInputChange(input)}
          onSelect={(selectedItem: ISuggestionItem) => roamingStore.selectCountrySuggestionItem(selectedItem, currentSegment)}
          input={{
            autoComplete: 'off',
          }}
          isClearable={true}
        />
      </LargeSearch>
    </>
  );
});

export default RoamingCountrySearch;
